import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';
import {SearchFilter} from '../../../shared/components/advanced-searchbox/advanced-searchbox.component';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {Attribute, AttributeOption} from '../../models/attribute';
import {LoadCollectionCommand} from '../../models/product-commands';
import {SortDirection, SortField, SortOrder} from '../../../shared/models/magento-search-filter';
import {SearchFilterConverter} from '../../services/search-filter-converter';
import {DOCUMENT} from "@angular/common";
import {MatSelect} from "@angular/material/select";
import {MultipleFieldSelect, SearchableAttribute} from "../../models/advanced-search";


//TODO: For next week, analyse search and resetting the form

@Component({
    selector: 'app-product-sorted-search',
    templateUrl: './product-sorted-search.component.html',
    styleUrls: ['./product-sorted-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSortedSearchComponent implements OnInit {

    private static DEFAULT_SORT_OPTION = [SortField.SKU.toUpperCase(), SortDirection.ASC]
    readonly fieldAdvancedSearchTextId = 'product-sorted-search_field-mobile-product-sorted-search';
    readonly fieldSortTextId = 'product-sorted-search_field-sort';

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    @Input()
    attributes: Attribute[];

    @Input()
    searchFilters: SearchFilter[];

    @Output()
    search = new EventEmitter<LoadCollectionCommand>();

    @Output()
    openAdvancedSearch = new EventEmitter();

    searchableAttributes: SearchableAttribute = {
        decor: {attributeCode: 'decor', i18id: 'product-sorted-search_field-decor'},
        occasion: {attributeCode: 'occasion', i18id: 'product-sorted-search_field-occasion'},
        productType: {attributeCode: 'product_type_hb', i18id: 'product-sorted-search_field-product-type'},
        purpose: {attributeCode: 'purpose', i18id: 'product-sorted-search_field-purpose'},
        productCategory: {attributeCode: 'product_category_hb', i18id: 'product-sorted-search_field-category'},
        color: {attributeCode: 'color', i18id: 'product-sorted-search_field-color'}
    }

    form = new FormGroup({
        decor: new FormControl({value: []}),
        productType: new FormControl({value: []}),
        occasion: new FormControl({value: []}),
        purpose: new FormControl({value: []}),
        category: new FormControl({value: []}),
        color: new FormControl({value: []}),
        sort: new FormControl(ProductSortedSearchComponent.DEFAULT_SORT_OPTION),
        advanced: new FormControl()
    });

    sortOptions = [
        {i18id: "product-sorted-search_sort-by-article", value: ['SKU', 'ASC']},
        {i18id: "product-sorted-search_sort-by-hi-price", value: ['PRICE', 'DESC']},
        {i18id: "product-sorted-search_sort-by-lo-price", value: ['PRICE', 'ASC']},
        {i18id: "product-sorted-search_sort-by-new-in", value: ['NEW', 'ASC']}
    ];

    multipleFieldSelections: MultipleFieldSelect[];


    get advancedControl(): AbstractControl {
        return this.form.get('advanced');
    }

    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    ngOnInit(): void {
        this.multipleFieldSelections = [
            {
                formName: 'decor',
                i18nId: this.searchableAttributes.decor.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.decor.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.decor.attributeCode, false)
            },
            {
                formName: 'productType',
                i18nId: this.searchableAttributes.productType.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.productType.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.productType.attributeCode)
            },
            {
                formName: 'occasion',
                i18nId: this.searchableAttributes.occasion.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.occasion.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.occasion.attributeCode)
            },
            {
                formName: 'purpose',
                i18nId: this.searchableAttributes.purpose.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.purpose.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.purpose.attributeCode)
            },
            {
                formName: 'category',
                i18nId: this.searchableAttributes.productCategory.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.productCategory.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.productCategory.attributeCode)
            },
            {
                formName: 'color',
                i18nId: this.searchableAttributes.color.i18id,
                panelClass: 'attribute-select',
                attributeCode: this.searchableAttributes.color.attributeCode,
                attributeOptions: this.getAttributeOptionsOf(this.searchableAttributes.color.attributeCode)
            }
        ]

        this.processSearchFilter(this.searchFilters);
        this.disableEmptyControls();
    }

    onOpenAdvancedSearch() {
        this.openAdvancedSearch.emit();
    }

    saveSelect(select: MatSelect) {
        select.close()
    }

    resetSearchSelect(type: string) {
        if (type === 'sort') {
            this.form.get(type).reset(ProductSortedSearchComponent.DEFAULT_SORT_OPTION)
        } else {
            this.form.get(type).reset([]);
        }

        this.submitSearch();
    }

    compare(c1: [string, string], c2: [string, string]): boolean {
        return c1 && c2 && c1[0] === c2[0];
    }

    onSelectOpen() {
        /* This "hack" is required since the mat-select is creating an overlay which is
        preventing buttons to be closed when clicked
        */
        const element = this.document.querySelector('.mat-select-panel-wrap');
        const parentOverlay = element.parentElement;
        parentOverlay.style.pointerEvents = "none"
    }

    resetDropdowns(): void {
        Object.entries(this.form.controls).forEach(formEntry => {
                const controlName = formEntry[0];
                const formControl = formEntry[1];

                if (controlName === 'advanced') {
                    formControl.reset('');
                    return;
                }

                if (controlName === 'sort') {
                    formControl.reset(ProductSortedSearchComponent.DEFAULT_SORT_OPTION);
                    return;
                }

                formControl.reset([]);
            }
        )

        this.submitSearch();
    }

    submitSearch(): void {
        let form = this.form.controls['sort'].value;
        const sortOrders = [{field: SortField[form[0]], direction: SortDirection[form[1]]}];
        const searchFilters = this.createSearchFilters();
        this.onSearch(searchFilters, sortOrders);
    }

    private createSearchFilters(): SearchFilter[] {
        let searchFilters = this.multipleFieldSelections.reduce<SearchFilter[]>((acc, curr) => {
            const searchFilter = this.form.controls[curr.formName].value.map(value => {
                    return {model: curr.attributeCode, value: value}
                }
            )

            if (searchFilter.length > 0) {
                acc.push(...searchFilter)
            }

            return acc
        }, [])

        if (this.advancedControl.value != null && (this.advancedControl.value as string).trim().length > 0) {
            const advancedValue = (this.advancedControl.value as string).trim();
            searchFilters.push({
                model: SearchFilterConverter.ADVANCED_FILTER_ATTRIBUTE_CODE,
                value: {
                    value: advancedValue,
                    label: advancedValue
                }
            });
        }
        return searchFilters;
    }

    private onSearch(searchFilters: SearchFilter[], sortOrders: SortOrder[]) {
        console.log('search was submitted', searchFilters);
        this.search.emit({searchFilters: searchFilters, sortOrders: sortOrders});
    }

    private getAttributeOptionsOf(code: string, sort = true): AttributeOption[] {
        const attribute = this.attributes.filter(a => a.code === code);
        if (attribute.length === 0) {
            return [];
        }

        const attributeOptions = attribute[0].options
            .filter(o => o.label.trim().length > 0 && o.value.trim().length > 0);

        if (sort) {
            return attributeOptions.sort((o1, o2) => {
                return o1.label.toLowerCase() < o2.label.toLowerCase() ? -1 : 1;
            });
        }

        return attributeOptions;
    }

    private processSearchFilter(searchFilters: SearchFilter[]) {
        if (searchFilters == null) {
            return;
        }

        this.multipleFieldSelections.forEach(selection => {
            this.form.controls[selection.formName].setValue(searchFilters
                .filter(f => f.model == selection.attributeCode)
                .map(f => f.value)
            )
        })

        // advanced:
        const advancedFilter = searchFilters.filter(f => f.model === SearchFilterConverter.ADVANCED_FILTER_ATTRIBUTE_CODE);
        if (advancedFilter.length > 0) {
            this.advancedControl.setValue(advancedFilter[0].value.value);
        }
    }

    private disableEmptyControls() {
        // reset disable / enable form control state.
        this.multipleFieldSelections.forEach(selection => {
            if (selection.attributeOptions.length === 0) {
                this.form.controls[selection.formName].disable();
            }
        })
    }
}
